import script from "./AuditDetailsGeneral.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditDetailsGeneral.vue?vue&type=script&lang=ts&setup=true"

import "./AuditDetailsGeneral.vue?vue&type=style&index=0&id=144cf7d5&lang=scss"

const __exports__ = script;

export default __exports__